module.exports = __webpack_public_path__ + "static/media/client10.5be70e20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/client10.png
// module id = 304
// module chunks = 0